module.exports = __webpack_public_path__ + "static/img/3681_phase_function_Paper_Points.30cdec1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3681_phase_function_Paper_Points.png
// module id = NSgB
// module chunks = 0